import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { FloppyDisk, X } from "@phosphor-icons/react";
import api from "../lib/api";

export default function EditLiveModal({ live, onClose, onSaved }) {
  const [contractors, setContractors] = useState([]);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    name: live.name || "",
    date: live.date || "",
    contractor_id: live.contractor_id || "",
    commission_pct: live.commission_pct ?? "",
    note: live.note || "",
  });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  useEffect(() => {
    api.get("/contractors").then(r => setContractors(r.data)).catch(() => {});
  }, []);

  const pickContractor = (cid) => {
    const c = contractors.find(x => x.id === cid);
    setForm(f => ({ ...f, contractor_id: cid, commission_pct: c?.commission_pct ?? f.commission_pct }));
  };

  const save = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return toast.error("Dê um nome para a live");
    const pct = form.commission_pct === "" || form.commission_pct === null
      ? null : parseFloat(String(form.commission_pct).replace(",", "."));
    if (pct !== null && (isNaN(pct) || pct < 0 || pct > 100)) return toast.error("Percentual deve ser entre 0 e 100");
    setSaving(true);
    try {
      await api.put(`/lives/${live.id}`, {
        name: form.name, date: form.date, note: form.note || null,
        contractor_id: form.contractor_id || null, commission_pct: pct,
        pix_key: live.pix_key || null, pix_type: live.pix_type || null, pix_name: live.pix_name || null,
      });
      toast.success("Live atualizada");
      onSaved();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erro ao salvar");
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="edit-live-modal" className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <form onSubmit={save} className="card-brutal bg-white w-full max-w-lg text-brand-ink">
        <div className="p-4 border-b-2 border-brand-ink flex items-center justify-between">
          <h2 className="font-heading text-xl font-black">Editar live</h2>
          <button type="button" data-testid="edit-live-close" onClick={onClose} className="p-1"><X weight="bold" size={18} /></button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div className="sm:col-span-2">
            <label className="label-brutal">Nome</label>
            <input data-testid="edit-live-name" className="input-brutal" value={form.name} onChange={(e) => set("name", e.target.value)} />
          </div>
          <div>
            <label className="label-brutal">Data</label>
            <input data-testid="edit-live-date" type="date" className="input-brutal" value={form.date} onChange={(e) => set("date", e.target.value)} />
          </div>
          <div>
            <label className="label-brutal">% da loja (comissão)</label>
            <input data-testid="edit-live-commission" inputMode="decimal" className="input-brutal" placeholder="ex.: 30" value={form.commission_pct} onChange={(e) => set("commission_pct", e.target.value)} />
          </div>
          <div className="sm:col-span-2">
            <label className="label-brutal">Contratante</label>
            <select data-testid="edit-live-contractor" className="input-brutal" value={form.contractor_id} onChange={(e) => pickContractor(e.target.value)}>
              <option value="">Nossa loja</option>
              {contractors.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="sm:col-span-2">
            <label className="label-brutal">Observação</label>
            <input data-testid="edit-live-note" className="input-brutal" value={form.note} onChange={(e) => set("note", e.target.value)} />
          </div>
        </div>
        <div className="p-4 border-t-2 border-brand-ink flex justify-end gap-2">
          <button type="button" onClick={onClose} className="btn-white h-[44px]">Cancelar</button>
          <button type="submit" data-testid="edit-live-save" disabled={saving} className="btn-pink h-[44px] disabled:opacity-60">
            <FloppyDisk weight="bold" size={16} /> {saving ? "Salvando…" : "Salvar"}
          </button>
        </div>
      </form>
    </div>
  );
}
